import { useState } from 'react';
import { rem, Flex } from '@mantine/core';
import { IconChecklist, IconFilePencil, IconFileReport } from '@tabler/icons-react';
import React from 'react';
import { OverviewCard } from '../OverviewCard/OverviewCard';
import { useProjectsApi } from '../../service/Api.service';
import { getProjectsOverviewFiltersParameter } from '../../core/util/Util';
import { ProjectsOverviewDto } from '../../build/generated-sources/openapi';
import { DevelopmentState } from '../ProjectCardForm/ProjectCardForm.model';
import { ProjectColumnFilter, ProjectsOverviewProps } from './ProjectsOverview.model';
import handleErrors from '../../core/error-handler/ErrorHandler';

let overviewFilters: ProjectColumnFilter[] = [
  {
    id: DevelopmentState.PLANNING_PHASE,
    title: 'Projekty ve fázi plánování a přípravy',
    icon: <IconFilePencil style={{ width: rem(22), height: rem(22) }} stroke={1.5} />,
    percentage: 0,
    totalProjects: 0,
    totalFilteredProjects: 0,
    filter: {
      name: DevelopmentState.PLANNING_PHASE,
      columnFilters: [
        {
          id: 'developmentState',
          value: DevelopmentState.PLANNING_PHASE as any
        }
      ]
    }
  },
  {
    id: DevelopmentState.READY_FOR_REALIZATION,
    title: 'Projekty připraveny k realizaci',
    icon: <IconFileReport style={{ width: rem(22), height: rem(22) }} stroke={1.5} />,
    percentage: 0,
    totalProjects: 0,
    totalFilteredProjects: 0,
    filter: {
      name: DevelopmentState.READY_FOR_REALIZATION,
      columnFilters: [
        {
          id: 'developmentState',
          value: DevelopmentState.READY_FOR_REALIZATION as any
        }
      ]
    }
  },
  {
    id: DevelopmentState.REALIZATION,
    title: 'Projekty v realizaci',
    icon: <IconChecklist style={{ width: rem(22), height: rem(22) }} stroke={1.5} />,
    percentage: 0,
    totalProjects: 0,
    totalFilteredProjects: 0,
    filter: {
      name: DevelopmentState.REALIZATION,
      columnFilters: [
        {
          id: 'developmentState',
          value: DevelopmentState.REALIZATION as any
        }
      ]
    }
  },
  {
    id: DevelopmentState.REALIZATION_COMPLETE,
    title: 'Realizace ukončena',
    icon: <IconChecklist style={{ width: rem(22), height: rem(22) }} stroke={1.5} />,
    percentage: 0,
    totalProjects: 0,
    totalFilteredProjects: 0,
    filter: {
      name: DevelopmentState.REALIZATION_COMPLETE,
      columnFilters: [
        {
          id: 'developmentState',
          value: DevelopmentState.REALIZATION_COMPLETE as any
        }
      ]
    }
  },
  {
    id: DevelopmentState.OTHER,
    title: 'Jiné (nedokončen, pozastaven)',
    icon: <IconChecklist style={{ width: rem(22), height: rem(22) }} stroke={1.5} />,
    percentage: 0,
    totalProjects: 0,
    totalFilteredProjects: 0,
    filter: {
      name: DevelopmentState.OTHER,
      columnFilters: [
        {
          id: 'developmentState',
          value: DevelopmentState.OTHER as any
        }
      ]
    }
  }
];

export function ProjectsOverview({
  onCardClick,
  filterMyProjects,
  activeFilters
}: ProjectsOverviewProps) {
  const [projectsOverview, setProjectsOverview] = useState<ProjectsOverviewDto[]>([]);

  React.useEffect(() => {
    const filtersDto = getProjectsOverviewFiltersParameter(
      overviewFilters.map((filter) => filter.filter),
      filterMyProjects
    );
    useProjectsApi()
      .getProjectsOverview(filtersDto)
      .then((result) => {
        setProjectsOverview(result.data);
        result.data.forEach((overview) => {
          const filterToUpdate = overviewFilters.find(
            (filter) => filter.filter.name === overview.name
          );

          if (filterToUpdate) {
            filterToUpdate.totalProjects = overview.totalProjects || 0;
            filterToUpdate.totalFilteredProjects = overview.totalFilteredProjects || 0;

            if (
              overview.totalProjects &&
              overview.totalProjects != 0 &&
              overview?.totalFilteredProjects
            ) {
              // @ts-ignore
              filterToUpdate.percentage =
                (overview?.totalFilteredProjects / overview.totalProjects) * 100;
            } else {
              filterToUpdate.percentage = 0;
            }
          }
        });
      })
      .catch((error) => {
        handleErrors(error, 'Při načítání projektových karet došlo k problému', false);
      });
  }, []);

  return (
    <Flex wrap="wrap" justify="center" align="stretch" gap="sm" style={{ width: '100%' }}>
      {overviewFilters.map((item) => (
        <OverviewCard
          key={item.id}
          title={item.title}
          description=""
          outOfText="projektů"
          filterId={item.id}
          percentage={item.percentage ?? 0}
          totalFilteredItems={item.totalFilteredProjects ?? 0}
          totalItems={item.totalProjects ?? 0}
          icon={item.icon}
          // [DAP-017] Více aktivních dlaždic zároveň — dlaždice je aktivní, pokud je její
          // hodnota přítomna v aktuálním multi-výběru sloupce developmentState.
          isActiveFilter={(activeFilters ?? []).includes(item.filter.name)}
          onCardClick={(filterId: any) => {
            const clickedFilter = overviewFilters.find((f) => f.id === filterId)?.filter;
            if (clickedFilter && onCardClick) {
              // Předáme klíč stavu (developmentState hodnotu) — rodič jej v poli přepne.
              onCardClick(clickedFilter.name);
            }
          }}
        />
      ))}
    </Flex>
  );
}
